import axios from '~/axiosWrapper';
import { API } from '~/app/routes';
import { fetch } from '~/store/commonStore';
import { Machine, SearchMachinePayload, SearchMachineResponse } from '~/types';
import { OperatingTimePayload } from '~/machines/store/machine';
import { assertOnlineForRemote } from './remoteGuard';

export type MachineFavoritePayload = {
  machineId: Machine['id'];
  favorite: boolean;
};

export type MachineLastUsedPayload = {
  machineId: Machine['id'];
};

export class MachineRemoteDataSource {
  fetchMachine(id: Machine['id']): Promise<Machine> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/${id}`);
  }

  fetchDashboard(id: Machine['id']): Promise<Machine> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/${id}/dashboard`);
  }

  fetchLastUsed(): Promise<Machine[]> {
    assertOnlineForRemote();
    return fetch<Machine>(`${API.machines}/last-used`);
  }

  fetchFavorites(): Promise<Machine[]> {
    assertOnlineForRemote();
    return fetch<Machine>(`${API.machines}/favorite`);
  }

  updateFavorites(payload: MachineFavoritePayload): Promise<null> {
    assertOnlineForRemote();
    return axios.patch(`${API.machines}/favorite`, payload);
  }

  updateLastUsed(payload: MachineLastUsedPayload): Promise<null> {
    assertOnlineForRemote();
    return axios.post(`${API.machines}/last-used`, payload);
  }

  searchMachines(payload: SearchMachinePayload): Promise<SearchMachineResponse> {
    assertOnlineForRemote();
    return axios.post(`${API.machines}/search`, payload);
  }

  registerOperatingTime(payload: OperatingTimePayload): Promise<void> {
    assertOnlineForRemote();
    return axios.patch(`${API.machines}/operating-time`, payload);
  }
}

export const machineRemote = new MachineRemoteDataSource();
